import React from 'react';
import { Award, Users, TrendingUp, Home } from 'lucide-react';

const ICON_MAP = {
  'Years in Banking': Award,
  'Happy Clients': Users,
  'Loans Processed': TrendingUp,
  'Properties Sold': Home,
};

export const AboutStats = ({ stats }) => (
  <div className="bg-gradient-to-r from-cyan-500 to-teal-600 rounded-2xl p-8 md:p-12 shadow-xl">
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
      {stats.map((stat) => {
        const Icon = ICON_MAP[stat.label];
        return (
          <div key={stat.label} className="text-center text-white">
            <div className="flex justify-center mb-3">
              {Icon && <Icon className="w-8 h-8" />}
            </div>
            <div className="text-4xl font-bold mb-2">{stat.value}</div>
            <div className="text-sm text-cyan-100">{stat.label}</div>
          </div>
        );
      })}
    </div>
  </div>
);

export default AboutStats;
